import React, {Component} from "react";
import {Link} from "react-router-dom";

import {Button, Card, CardBody, Row} from "reactstrap";

import Constants from "../../../constants/constants.js";

import "./team-member-card.css"

class TeamMemberCard extends Component {
    async lockoutButtonClicked() {
        let {lockout_func, teamMember} = this.props;

        let newLockdownStatus = !teamMember.lockout;

        await lockout_func(teamMember.id, newLockdownStatus);
    }

    render() {
        const {teamMember, role, isAdminRole, me} = this.props;    
        let canLockout = !me && role && role.level > Constants.ORGANIZATION_ADMIN_ROLE_LEVEL;

        let canEdit = isAdminRole && role && role.level > Constants.ORGANIZATION_ADMIN_ROLE_LEVEL;

        let lockoutMessage = teamMember.lockout ? <span className='team_member_card_locked_out_message'>[Locked out]</span> : "";

        
        let lockoutButtonText = <span><span>Lockout</span><i className='fa fa-lock lockout_button_icon'></i></span>;
        let lockoutButtonClass = "team_member_lockout_button lock";

        if (teamMember.lockout) {
            lockoutButtonText = <span><span>Unlock</span> <i className='fa fa-unlock-alt lockout_button_icon'></i></span>;
            lockoutButtonClass = "team_member_lockout_button unlock";
        }
        

        return (
            <Card className="my-2">
                <CardBody className="m-2">
                    <Row>
                        <span className="mr-2 font-weight-bold">
                            Name:
                        </span>
                        {teamMember.name} {lockoutMessage}
                    </Row>
                    <Row>
                        <span className="mr-2 font-weight-bold">
                            Role:
                        </span>
                        {role && role.name}
                    </Row>
                    <Row>
                        <span className="mr-2 font-weight-bold">
                            Occupation:
                        </span>
                        {teamMember.occupation}
                    </Row>
                    <Row>
                        <span className="mr-2 font-weight-bold">
                            Number of Players:
                        </span>
                        {teamMember.number_of_players}
                    </Row>
                    <Row>
                        <span className="mr-2 font-weight-bold">
                            Phone Number:
                        </span>
                        {teamMember.phone_number}
                    </Row>
                    <Row>
                        <span className="mr-2 font-weight-bold">
                            Username:
                        </span>
                        {teamMember.login}
                    </Row>
                    {canEdit &&
                    <Row>
                        <Link to={`teamMember/${teamMember.id}`}>
                            <Button size="sm" color="secondary" className="mr-1">Edit</Button>
                        </Link>
                        {canLockout && <button onClick={this.lockoutButtonClicked.bind(this)} className={lockoutButtonClass}>{lockoutButtonText}</button>}
                    </Row>
                    }

                </CardBody>
            </Card>
        )
    }
}

export default TeamMemberCard;



// WEBPACK FOOTER //
// ./src/components/components/team-member-card/team-member-card.js